import { render, staticRenderFns } from "./bill_id.vue?vue&type=template&id=ec884364&scoped=true"
import script from "./bill_id.vue?vue&type=script&lang=js"
export * from "./bill_id.vue?vue&type=script&lang=js"
import style0 from "./bill_id.vue?vue&type=style&index=0&id=ec884364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec884364",
  null
  
)

export default component.exports